import React, { useCallback, useState } from 'react'
import message from 'antd/lib/message'

import apiManager from 'helpers/apiManager'
import DarkPrimaryButton from 'components/DarkPrimaryButton'
import InputModal from 'pages/admin/AdminAnalytics/InputModal'

const analytics = [
  {
    title: 'Active Users with Missing Data',
    path: 'users/active/missing-data',
  },
  {
    title: 'Match Recommendations Analysis',
    path: 'match-recommendations/analysis',
  },
  {
    title: 'User Match Recommendations',
    path: 'match-recommendations/user',
    requiredData: [
      {
        label: 'User ID/Username/Email',
        name: 'userIdentifier',
        type: 'text',
        required: true,
      },
    ],
  },
  {
    title: 'Active Match Recommendations',
    path: 'match-recommendations/active',
  },
  {
    title: 'Unrevealed Match Recommendations',
    path: 'match-recommendations/unrevealed',
  },
  {
    title: 'No Decision Match Recommendations',
    path: 'match-recommendations/no-decision',
  },
  {
    title: 'Past 2 weeks Match Recommendations',
    path: 'match-recommendations/past-2-weeks',
  },
  {
    title: 'Paid Subscriptions',
    path: 'subscriptions/paid',
  },
  {
    title: 'Unpaid Subscriptions',
    path: 'subscriptions/unpaid',
  },
  {
    title: 'Paid Subscriptions on Trials',
    path: 'subscriptions/paid/trials',
  },
  {
    title: 'Users by Referral Code',
    path: 'users/referralCode',
    requiredData: [
      {
        label: 'Referral Code',
        name: 'referralCode',
        type: 'text',
        required: true,
      },
    ],
  },
  {
    title: 'Event Signups',
    path: 'event/signups',
    requiredData: [
      {
        label: 'Event ID',
        name: 'eventId',
        type: 'number',
        required: true,
      },
    ],
  },
]

const AdminAnalytics = () => {
  const [selectedAnalytics, setSelectedAnalytics] = useState(null)

  const downloadAnalytics = useCallback(async params => {
    try {
      const blob = await apiManager.adminDownloadAnalytics(params)
      const file = window.URL.createObjectURL(blob)
      window.location.assign(file)
      setSelectedAnalytics(null)
    } catch (error) {
      message.destroy()
      message.error(error.message || 'Please try again')
    }
  }, [])

  const handleDownload = useCallback(
    async analyticsData => {
      if (analyticsData.requiredData) {
        setSelectedAnalytics(analyticsData)
        return
      }

      return downloadAnalytics({ path: analyticsData.path })
    },
    [downloadAnalytics]
  )

  return (
    <div className="w-full min-h-screen px-4 bg-white py-4 md:px-10">
      <h1 className="text-4xl text-center mb-8">Analytics</h1>
      <div>
        {analytics.map((analyticsData, index) => (
          <div key={index} className="mb-4">
            <DarkPrimaryButton className="w-full" onClick={() => handleDownload(analyticsData)}>
              {analyticsData.title}
            </DarkPrimaryButton>
          </div>
        ))}
      </div>
      <InputModal
        show={!!selectedAnalytics}
        title={selectedAnalytics?.title}
        onClose={() => setSelectedAnalytics(null)}
        onSubmit={data => downloadAnalytics({ path: selectedAnalytics.path, data })}
        requiredData={selectedAnalytics?.requiredData}
      />
    </div>
  )
}

export default AdminAnalytics
